// Full-document render of the Oscar thank-you (order confirmation) view:
// PageSkeleton (the React document shell) wrapping ThankYouPageBody. The
// deferred GA4 dataLayer events (ga_ecom + ga_purchase) and Google Seller
// Ratings survey opt-in (ga_seller) inject after hydration.
// Header/footer slots are omitted so the default site chrome renders.
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";
import { GASeller } from "tsi-common-react/src/components/GASeller/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ThankYouPageBody } from "../components/ThankYouPageBody";

export const Template = (
    props: templates.ThankYouDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ThankYouPageBody {...props} />
            <DataLayerPush events={props.ga_events} />
            <GASeller surveyData={props.ga_seller_survey_data} />
        </PageSkeleton>
    );
};
